import { FunctionComponent } from 'react';

import styles from './WidgetCard.module.scss';

export type WidgetCardProps = {
  title?: string;
  select?: React.JSX.Element;
  buttons?: React.JSX.Element;
  content?: React.JSX.Element;
};

type FC = FunctionComponent<WidgetCardProps>;

const WidgetCard: FC = ({ title, select, buttons, content }: WidgetCardProps) => (
  <div className={styles.container}>
    <div className={styles.titleContainer}>
      <h3>{title}</h3>
      <div className={styles.buttonContainer}>
        {buttons}
        {select}
      </div>
    </div>
    <div>{content}</div>
  </div>
);

export default WidgetCard;
